<template>
    <sidebar-menu :items="reports" :force-expanded="forceExpanded" @update:expanded="$emit('update:expanded', $event)" />
</template>

<script>
import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';
import {
    COURSE_GRADEBOOK_REPORT,
    COURSE_SCHEMA_REPORT,
    COURSE_TEMPLATE_SCHEMA_REPORT,
    COURSES_WITH_UNGRADED_SUBMISSIONS_REPORT,
    FAILED_COURSE_REPORT,
    GROUP_COURSE_REPORT,
    GROUP_DISCUSSIONS_REPORT,
    INSTRUCTOR_DISCUSSIONS_REPORT,
    LATE_OR_MISSED_MEETINGS_REPORT,
    MEETING_COUNT_REPORT,
    MEETING_STATUS_REPORT,
    MISSING_COURSE_GRADES_REPORT,
    MISSING_SUBMISSIONS_REPORT,
    RISK_ASSESSMENT_REPORT,
    USER_ACTIVITY_REPORT,
    USER_IMPRESSIONS_REPORT,
} from '@/pages/reports/ReportPermissions.js';

export default {
    name: 'ReportsSidebar',

    components: { SidebarMenu },

    props: {
        forceExpanded: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:expanded'],

    computed: {
        reports() {
            return [
                {
                    type: 'folder',
                    title: 'People',
                    icon: 'pi pi-users',
                    items: [
                        {
                            type: 'item',
                            title: 'Impressions',
                            route: { name: 'user-impressions-report' },
                            canSee: this.$gate.allows('view', ['Report', USER_IMPRESSIONS_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Activity',
                            route: { name: 'user-activity-report' },
                            canSee: this.$gate.allows('view', ['Report', USER_ACTIVITY_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Early Warning',
                            route: { name: 'risk-assessment-report' },
                            canSee:
                                this.$gate.allows('view', ['Report', RISK_ASSESSMENT_REPORT]) ||
                                this.$gate.userCanViaGroup('view risk assessment report'),
                        },
                    ],
                },
                {
                    type: 'folder',
                    title: 'Course',
                    icon: 'pi pi-book',
                    items: [
                        {
                            type: 'folder',
                            title: 'Engagement',
                            canSee:
                                this.$gate.allows('view', ['Report', GROUP_DISCUSSIONS_REPORT]) ||
                                this.$gate.allows('view', ['Report', INSTRUCTOR_DISCUSSIONS_REPORT]),
                            items: [
                                {
                                    type: 'item',
                                    title: 'Discussions',
                                    route: {
                                        name: 'discussions-report',
                                        params: { view: 'course' },
                                    },
                                    canSee:
                                        this.$gate.allows('view', ['Report', GROUP_DISCUSSIONS_REPORT]) ||
                                        this.$gate.allows('view', ['Report', INSTRUCTOR_DISCUSSIONS_REPORT]),
                                },
                            ],
                        },

                        {
                            type: 'item',
                            title: 'Gradebook',
                            route: { name: 'course-gradebook-report' },
                            canSee: this.$gate.allows('view', ['Report', COURSE_GRADEBOOK_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Groups',
                            route: { name: 'group-course-report' },
                            canSee: this.$gate.allows('view', ['Report', GROUP_COURSE_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Ungraded Submissions',
                            route: {
                                name: 'courses-with-ungraded-submissions-report',
                            },
                            canSee: this.$gate.allows('view', ['Report', COURSES_WITH_UNGRADED_SUBMISSIONS_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Meeting Status',
                            route: { name: 'meeting-status-report' },
                            canSee: this.$gate.allows('view', ['Report', MEETING_STATUS_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Late or Missed Meetings',
                            route: { name: 'late-or-missed-meetings-report' },
                            browserNavigate: true,
                            canSee: this.$gate.allows('view', ['Report', LATE_OR_MISSED_MEETINGS_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Failed Course',
                            route: { name: 'failed-course-report' },
                            canSee: this.$gate.allows('view', ['Report', FAILED_COURSE_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Missing Submissions',
                            route: { name: 'missing-submissions-report' },
                            canSee: this.$gate.allows('view', ['Report', MISSING_SUBMISSIONS_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Missing Course Grades',
                            route: { name: 'missing-course-grades-report' },
                            browserNavigate: true,
                            canSee: this.$gate.allows('view', ['Report', MISSING_COURSE_GRADES_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Meeting Count',
                            route: { name: 'meeting-count-report' },
                            canSee: this.$gate.allows('view', ['Report', MEETING_COUNT_REPORT]),
                        },
                        {
                            type: 'item',
                            title: 'Schema Report',
                            route: { name: 'course-schema-report' },
                            canSee: this.$gate.allows('view', ['Report', COURSE_SCHEMA_REPORT]),
                        },
                    ],
                },
                {
                    type: 'folder',
                    title: 'Course Template',
                    icon: 'pi pi-clipboard',
                    items: [
                        {
                            type: 'item',
                            title: 'Schema Report',
                            route: { name: 'course-template-schema-report' },
                            canSee: this.$gate.allows('view', ['Report', COURSE_TEMPLATE_SCHEMA_REPORT]),
                        },
                    ],
                },
            ];
        },
    },
};
</script>
